import React from "react";

const Modal = ({ idModal, titulo, footer, children, variant, foto }) => {
  return (
    <div class="modal" id={idModal} aria-hidden="true">
      <div
        class={
          foto
            ? "modal-dialog-foto modal-dialog"
            : `modal-dialog-${variant ?? "default"}`
        }
      >
        {titulo && (
          <div class="modal-header">
            <h2>{titulo}</h2>
            <a href="#root" class="btn-close" aria-label="Fechar modal">
              ×
            </a>
          </div>
        )}
        <div class="modal-body">{children}</div>
        {footer && <div class="modal-footer">{footer?.()}</div>}
      </div>
    </div>
  );
};

export default Modal;
